import {combineReducers} from 'redux'
import AppReducer from './AppReducer'
import DetailsReducer from './DetailsReducer'
import { routerReducer } from 'react-router-redux'

const allReducers = combineReducers({
	appReducer:     AppReducer,
    detailsReducer: DetailsReducer,
	routing:        routerReducer
})

export default allReducers;



// WEBPACK FOOTER //
// ./reducers/reducers.js